import mock from 'src/utils/mock';
import { LabRegistration as LabRegistrationInterface } from 'src/types/labRegistration';
const labRegistration: LabRegistrationInterface[] = [
    {
        RegLabID: 9001,
        LabName: 'Sterling Alpha LabsXx',
        LabPhone1: '9855404659',
        LabPhone2: '9855404611',
        LabAddress1: '10 Green Society',
        LabAddress2: 'Patel Nagar',
        LabAddress3: '',
        City: 'Jalandhar',
        State: 'Punjab',
        Country: 'India',
        PinCode: '144001',
        LabRegistrationNo: '1R23Lab2023',
        LabRegistratonDate: '2020-01-01T00:00:00.000Z',
        LabEmailID: 'Info@alphalabs.com',
        Count_SubLabs_Mapped: 5,
        Count_SubLabs_Mapping_Left: 3,
        IsLab_ABHA_HFR_Registered: 'N',
        ABHA_HFR_ID: '',
        Remarks: 'This is a update API Test',
        Comments: null,
        CreationDt: '2023-07-19T14:32:22.033Z',
        ValidFrom: '2023-07-19T14:32:22.033Z',
        ValidUpto: '2034-06-30T14:32:22.033Z',
        Total_SubLabs_Allowed: 5,
    },
];

const labRegistrationDetail: LabRegistrationInterface[] = [
    {
        RegLabID: 9001,
        LabName: 'Sterling Alpha LabsXx',
        LabPhone1: '9855404659',
        LabPhone2: '9855404611',
        LabAddress1: '10 Green Society',
        LabAddress2: 'Patel Nagar',
        LabAddress3: '',
        City: 'Jalandhar',
        State: 'Punjab',
        Country: 'India',
        PinCode: '144001',
        LabRegistrationNo: '1R23Lab2023',
        LabRegistratonDate: '2020-01-01T00:00:00.000Z',
        LabEmailID: 'Info@alphalabs.com',
        Count_SubLabs_Mapped: 5,
        Count_SubLabs_Mapping_Left: 3,
        IsLab_ABHA_HFR_Registered: 'N',
        ABHA_HFR_ID: '',
        Remarks: 'This is a update API Test',
        Comments: null,
        CreationDt: '2023-07-19T14:32:22.033Z',
        ValidFrom: '2023-07-19T14:32:22.033Z',
        ValidUpto: '2034-06-30T14:32:22.033Z',
        Total_SubLabs_Allowed: 5,
    },
];

mock.onPost('/getLabInfo/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, labRegistration]);
        }, 1000);
    });
});
mock.onPost('/getLabDetailInfo/').reply((config) => {
    const params = JSON.parse(config.data);
    const labRegistrationData = labRegistrationDetail.filter((item) => item.RegLabID === params.id)[0];
    return [200, { ...labRegistrationData }];
});
